export const PRE_PROCESSING = 'PRE_PROCESSING';
export const PROCESSING = 'PROCESSING';
export const PROCESSED = 'PROCESSED';
